var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CreateAppCardHeaderText, CreateAppCardImage, CreateAppCardSubTitleText, CreateAppTypeCardContainer, } from '../styles';
var CreateTypeCard = function (_a) {
    var image = _a.image, headerText = _a.headerText, subTitleText = _a.subTitleText, imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, onClick = _a.onClick, left = _a.left, right = _a.right;
    return (_jsxs(CreateAppTypeCardContainer, __assign({ left: left, right: right, onClick: onClick }, { children: [_jsx(CreateAppCardImage, { imgHeight: imageHeight, imgWidth: imageWidth, src: image, alt: "app_type" }), _jsx(CreateAppCardHeaderText, { children: headerText }), _jsx(CreateAppCardSubTitleText, { children: subTitleText })] })));
};
export default CreateTypeCard;
